export default __webpack_public_path__ + "static/lol-cd9c6e31eec17db430e8ba59ee734b4b.jpg";